import { Component } from '@angular/core';
import { NavController, ToastController, LoadingController, ViewController, NavParams } from 'ionic-angular';

import { Reviews  } from '@providers/asset/index';
import { LocationPage, DetailReviewPage } from '../';
import { HelperMyRadiant, UserAsset } from '@providers/index';


@Component({
  selector: 'page-review',
  templateUrl: 'page.html'
})
export class ReviewPage {

  List: any = [];
  loading : any;
  can_delete = false;

  constructor(
    public navCtrl: NavController,
    public reviewApi: Reviews,
    public toastCtrl: ToastController,
    public loadingCtrl: LoadingController,
    public viewCtrl: ViewController,
    public navParams: NavParams,
    public helper : HelperMyRadiant,
    public userApi : UserAsset,
  ) {
    
    if (this.userApi.akses.delete_review_asset) {
      this.can_delete = true;
    }
  }

  ionViewDidEnter() {
    this.getList();
  }

  doRefresh(refresher) {
    refresher.complete();
    this.getList();
  }

  getList(){
    let loading = this.loadingCtrl.create({
      content: 'Please wait...'
    });
    loading.present();

    let params = { };
    this.reviewApi.get(params).subscribe((resp:any) => {
      this.List = resp.data;
      loading.dismiss();
    }, (err) => {
      loading.dismiss();
    });

  }

  getDetail(item){
    this.navCtrl.push(DetailReviewPage, {
      item:item
    });
  }

  select(){

  }
  
  add(){
    let params= {review:1};
    this.navCtrl.push(LocationPage,params);
  }

  deleteReviews(item) {
    let params = {
      id : item.id,
      tender_id : item.tender_id
    }

    let me = this,
      optionsSwal = {
      title: "Are you sure ?",   
      desc:"Once you delete reviews, you cant't undo it. ",   
      icon: "",
      dangerMode: false,
      btnCancel: "Cancel",
      btnConfirm: "Delete",
    }
    this.helper.presentSwalConfirmation(optionsSwal, () => {
      me.loading = me.helper.showLoading("Please Wait...");
      me.reviewApi.delete(params).subscribe((resp:any) => {        
        if (resp.success) {       
          try {
            me.loading.dismiss();
          } catch (error) {
          }
          me.helper.presentToast(resp.msg);
          me.getList();
        } else {
          me.helper.presentToast(resp.msg);
        }
      }, (err) => {
        try {
          me.loading.dismiss();
        } catch (error) {

        }
      });
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/asset/reviews/page.ts